// Jobs Store
import { clone } from 'lodash'

const job = {
  id: null,
  location: null,
  field: null,
  employment_type: null,
  available_in: null,
  title: null,
  tasks: [],
  profile: null,
  offer: null,
  img: null,
}

const state = {
  filterActive: false,
  filterOptions: [],
  filters: {},
  job: clone(job),
  jobPagination: {},
  jobs: [],
  pagination: {},
  pending: false,
}

const getters = {}

const actions = {
  getJobs({ commit }, page = 1) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItems('jobs', { page })
      .then(({ data }) => {
        commit('SET_JOBS', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getJob({ commit }, id) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getItem(`jobs.${id}`)
      .then(({ data }) => {
        commit('SET_JOB', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  getJobsFilters({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
      .getFilters('jobs')
      .then(({ data }) => {
        commit('SET_JOBS_FILTERS', data)
        commit('SET_PENDING')
        resolve()
      })
    })
  },
  filterJobs({ commit, state }, { page }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      const apiFilter = {}
      Object.keys(state.filters).forEach(function(key) {
        apiFilter[key] = [state.filters[key]]
      })

      this.api.items
        .filterItems('jobs', {
          ...apiFilter,
          page,
        })
        .then(({ data }) => {
          commit('SET_JOBS', data)
          commit('SET_FILTER_ACTIVE')
          commit('SET_PENDING')
          resolve()
        })
    })
  },
  setFilterActive({ commit }) {
    commit('SET_FILTER_ACTIVE')
  },
  updateFilters({ commit }, data) {
    commit('UPDATE_FILTERS', data)
  },
  resetFilter({ commit }) {
    commit('RESET_FILTER')
  },
  clearJobs({ commit }) {
    commit('CLEAR_JOBS')
  },
  clearJob({ commit }) {
    commit('CLEAR_JOB')
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  CLEAR_JOBS(state) {
    state.filterActive = false
    state.filterOptions = []
    state.filters = {}
    state.pagination = {}
    state.jobs = []
  },
  CLEAR_JOB(state) {
    state.jobPagination = {}
    state.job = clone(job)
  },
  RESET_FILTER: state => {
    state.filterActive = false
    state.filters = {}
  },
  SET_JOBS_FILTERS: (state, data) => {
    state.filterOptions = data
  },
  UPDATE_FILTERS: (state, data) => {
    state.filters = data
  },
  SET_FILTER_ACTIVE: state => {
    state.filterActive = true
  },
  SET_JOBS: (state, { jobs, pagination }) => {
    state.jobs = jobs
    state.pagination = pagination
  },
  SET_JOB: (state, { job, pagination }) => {
    state.job = job
    state.jobPagination = pagination
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
